@if (navigateUrl) {
  <div
    [class.text-center]="isStandaloneWidget"
    [class.text-start]="!isStandaloneWidget"
    [class.text-lg-center]="!isStandaloneWidget"
    class="navigation__content--padding"
  >
    <div
      class="nav-profile__action-item fw-bold"
      translate
    >
      Information
    </div>
    <div class="nav-profile__action-item">
      <a
        appUnsavedFormCheck
        appUrlPrefix
        [value]="navigateUrl"
        class="nav-link about-us p-0"
      >
        {{ 'UI.Common.AboutUs' | translate }}
      </a>
    </div>
  </div>
}

@if (isTenantAdmin) {
  <div
    [class.text-center]="isStandaloneWidget"
    class="navigation__content--padding"
  >
    <div
      [class.text-start]="!isStandaloneWidget"
      class="nav-profile__action-item fw-bold text-lg-center"
    >
      {{ 'UI.Common.Admin' | translate }}
    </div>
    <div class="nav-profile__action-item">
      <a
        appUnsavedFormCheck
        [class.text-start]="!isStandaloneWidget"
        class="nav-link p-0 text-lg-center"
        [href]="adminSettingsUrl"
      >
        {{ 'Settings' | translate }}
      </a>
    </div>
    <div class="nav-profile__action-item">
      <button
        class="btn btn-outline-primary w-100 py-0 font-size-base d-flex align-items-center justify-content-center"
        appRequireLogin
        (click)="
          $event.stopPropagation(); $event.preventDefault(); openExportPopup()
        "
      >
        <ng-icon
          name="matUploadFileRound"
          class="me-1"
        ></ng-icon>
        {{ 'Common.Export' | translate }}
      </button>
    </div>
  </div>
}
<div
  [class.d-none]="isStandaloneWidget"
  class="navigation__content--padding d-md-none"
>
  <app-languages></app-languages>
</div>
<div
  [class.d-none]="isStandaloneWidget"
  class="navigation__content--padding d-md-none add-home-screen"
>
  <app-add-home-screen></app-add-home-screen>
</div>
